module.exports = __webpack_public_path__ + "static/scale-model-of-reiman-aquarium-in-milwaukee-wisconsin-53c6eb43511cdd17baefb7484958fd76.png";